import React, { useCallback, useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { format } from 'date-fns';
import setUiMessage from '../../../Utilities/Tostify';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import RecurrencePopup from '../Appointment/RecurrencePopup';
import Button from '../../Button';
import { useSelector } from 'react-redux';

function AddTaskPopup({
  eventData = null,
  handleClose,
  handleReload = () => {},
  recurrCheck = false,
  fromCalFlag = false,
}) {
  const { user } = useSelector((state) => state.auth);
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const [allData, setAllData] = useState(null);
  const [provider, setProvider] = useState(eventData?.user_id || user?.id);
  const [location, setLocation] = useState(eventData?.location_id || 'all');
  const [textDesc, setTextDesc] = useState(eventData?.task_description || '');
  const [isBlocked, setIsBlocked] = useState(
    eventData ? (eventData?.blocked_flag === '0' ? '0' : '2') : '0'
  );

  // const [taskDate, setTaskDate] = useState({
  //   stDate: eventData?.task_start_time
  //     ? new Date(eventData?.task_start_time)
  //     : new Date(),
  //   ndDate: eventData?.task_end_time
  //     ? new Date(eventData?.task_end_time)
  //     : null,
  // });

  // const [startDate, setStartDate] = useState(
  //   eventData?.task_start_time
  //     ? new Date(eventData?.task_start_time)
  //     : new Date()
  // );
  const [startDate, setStartDate] = useState(() => {
    const date = eventData?.task_start_time
      ? new Date(eventData?.task_start_time)
      : new Date();

    // Set the time to midnight only if the date is created from `new Date()`
    if (!eventData?.task_start_time) {
      date.setHours(0, 0, 0, 0);
    }

    return date;
  });
  const [startTime, setStartTime] = useState(
    eventData?.task_start_time ? new Date(eventData?.task_start_time) : null
  );
  const [endDate, setEndDate] = useState(
    eventData?.task_end_time ? new Date(eventData?.task_end_time) : null
  );
  const [endTime, setEndTime] = useState(
    eventData?.task_end_time ? new Date(eventData?.task_end_time) : null
  );

  const [startDateOcc, setStartDateOcc] = useState(
    eventData?.task_start_time
      ? new Date(eventData?.task_start_time)
      : new Date()
  );
  const [startTimeOcc, setStartTimeOcc] = useState(
    eventData?.task_start_time ? new Date(eventData?.task_start_time) : null
  );
  const [endTimeOcc, setEndTimeOcc] = useState(
    eventData?.task_end_time ? new Date(eventData?.task_end_time) : null
  );

  const [stDatePickerIsOpen, setStDatePickerIsOpen] = useState(false);
  const [stTimePickerIsOpen, setStTimePickerIsOpen] = useState(false);

  const [ndDatePickerIsOpen, setNdDatePickerIsOpen] = useState(false);
  const [ndTimePickerIsOpen, setNdTimePickerIsOpen] = useState(false);

  const [editMode, setEditMode] = useState(
    eventData?.blocked_flag ? false : false
  );

  const [conFirmDelete, setConFirmDelete] = useState({ status: false, id: 0 });
  const [recurringCheck, setRecurringCheck] = useState(
    recurrCheck ? (recurrCheck === '1' ? true : false) : false
  );
  const [recurranceFormData, setRecurranceFormData] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await post(
        'api/appointment/appointment/openAddTaskPopup',
        {
          taskId: eventData?.indv_task_id ? eventData?.indv_task_id : 0,
        }
      );
      if (response.status === 200) {
        setAllData(response?.data);
      }
    })();
  }, [eventData?.indv_task_id]);

  const handleRecurErrors = (recurranceFormData) => {
    let flag = false;
    if (recurranceFormData.occur_type === '0') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on');
        flag = true;
      }
      if (
        recurranceFormData?.chckMon === 0 &&
        recurranceFormData?.chckTue === 0 &&
        recurranceFormData?.chckWed === 0 &&
        recurranceFormData?.chckThu === 0 &&
        recurranceFormData?.chckFri === 0 &&
        recurranceFormData?.chckSat === 0 &&
        recurranceFormData?.chckSun === 0
      ) {
        setUiMessage('err', 'Select any week day for processing.');
        flag = true;
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '1') {
      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select days of.');
          flag = true;
        }
        if (recurranceFormData?.recur_value === '') {
          setUiMessage('err', 'Select months(s).');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select value from dropdown');
          flag = true;
        }
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select day from dropdown');
          flag = true;
        }
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '2') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on.');
        flag = true;
      }

      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select on the field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on the second field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on the last field from recurrence.');
          flag = true;
        }
      }

      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    return flag;
  };

  const handleSaveTask = async () => {
    const selectElement = document.getElementById('providerid');
    const selectedText =
      selectElement.options[selectElement.selectedIndex].text;
    if (!recurringCheck && !startDate) {
      setUiMessage('war', 'Start date can not be blank.');
      return;
    } else if (!recurringCheck && !startTime) {
      setUiMessage('war', 'Start time can not be blank.');
      return;
    } else if (!recurringCheck && !endDate) {
      setUiMessage('war', 'End date can not be blank.');
      return;
    } else if (!recurringCheck && !endTime) {
      setUiMessage('war', 'End time can not be blank.');
      return;
    } else if (
      !recurringCheck &&
      (Date.parse(startDate) > Date.parse(endDate) ||
        Date.parse(startTime) >= Date.parse(endTime))
    ) {
      setUiMessage(
        'war',
        'Can not select end time less than or equal to start time.'
      );
      return;
    } else if (recurringCheck && !startDateOcc) {
      setUiMessage('war', 'Start date can not be blank.');
      return;
    } else if (recurringCheck && !startTimeOcc) {
      setUiMessage('war', 'Start time can not be blank.');
      return;
    } else if (recurringCheck && !endTimeOcc) {
      setUiMessage('war', 'End time can not be blank.');
      return;
    } else if (
      recurringCheck &&
      Date.parse(startTimeOcc) >= Date.parse(endTimeOcc)
    ) {
      setUiMessage(
        'war',
        'Can not select end time less than or equal to start time.'
      );
      return;
    } else if (selectedText === '') {
      setUiMessage('war', 'Please select resource.');
      return;
    } else if (recurringCheck && handleRecurErrors(recurranceFormData)) {
    } else {
      try {
        let pramsObj;
        let prams = {
          taskId: eventData?.indv_task_id,
          resource_id: provider,
          taskLocation: location,
          taskDescription: textDesc,
          block_flag: isBlocked,
          startDate:
            !recurringCheck && startDate ? format(startDate, 'yyyy-MM-dd') : '',
          startTime:
            !recurringCheck && startTime ? format(startTime, 'hh:mm a') : '',
          endDate:
            !recurringCheck && endDate ? format(endDate, 'yyyy-MM-dd') : '',
          endTime: !recurringCheck && endTime ? format(endTime, 'hh:mm a') : '',
          loginUserId: user?.id,
          appmtOption: recurringCheck ? '1' : '0',
          startDateOcc:
            recurringCheck && startDateOcc
              ? format(startDateOcc, 'yyyy-MM-dd')
              : '',
          startTimeOcc:
            recurringCheck && startTimeOcc
              ? format(startTimeOcc, 'hh:mm a')
              : '',
          endTimeOcc:
            recurringCheck && endTimeOcc ? format(endTimeOcc, 'hh:mm a') : '',
        };
        if (recurringCheck) {
          pramsObj = Object.assign({}, prams, recurranceFormData);
        } else {
          pramsObj = prams;
        }

        const response = await post(
          'api/appointment/Appointment/saveThisTask',
          pramsObj
          // {
          //   taskId: eventData?.indv_task_id,
          //   resource_id: provider,
          //   taskDescription: textDesc,
          //   block_flag: isBlocked ? '0' : '1',
          //   startDate: taskDate?.stDate
          //     ? format(taskDate?.stDate, 'yyyy-MM-dd')
          //     : '',
          //   startTime: taskDate?.stDate
          //     ? format(taskDate?.stDate, 'hh:mm a')
          //     : '',
          //   endDate: taskDate?.ndDate
          //     ? format(taskDate?.ndDate, 'yyyy-MM-dd')
          //     : '',
          //   endTime: taskDate?.ndDate
          //     ? format(taskDate?.ndDate, 'hh:mm a')
          //     : '',
          //   loginUserId: user?.id,
          // }
        );
        if (response.status === 200) {
          if (response.data.successCode === '1') {
            setUiMessage('suc', 'Task save successfully');
            handleClose();
            handleReload();
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    }
  };

  const handleDeleteTask = (taskId) => {
    setConFirmDelete((prev) => ({ ...prev, status: true, id: taskId }));
  };

  const handleDeleteTempletConfirm = async (taskId) => {
    const response = await post('api/appointment/appointment/deleteThisTask', {
      taskId: taskId,
      recurringId: eventData?.recurring_id,
      placeOfDel: '0',
      delType: recurrCheck ? recurrCheck : '0', //'0' -> for one, '1' -> for all
      loginUserId: user?.id,
    });
    if (response.status === 200) {
      if (response.data?.status === '1') {
        setUiMessage('suc', 'Task delete successfully');
        handleClose();
        handleReload();
      } else {
        setUiMessage('err', 'Something went wrong. Unable to delete task.');
      }
    }
  };

  const handleRecurranceFormData = useCallback((data) => {
    setRecurranceFormData(data);
  }, []);

  return (
    <div className="modalBackground">
      <div className="sch-addtsk-main-block">
        <div className="flex-sec item-center justify-between sch-addtsk-hdr-header">
          <span className="add-tsk-head">
            {eventData?.id ? 'Task' : 'New Task'}
          </span>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Resource:</span>
            <span className="add-tsk-body-row-value">
              <select
                id="providerid"
                className="chzn-select room-alot-selct width245-s"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
                disabled={editMode}
              >
                <option value=""></option>
                {allData?.allResourceWithCode.length > 0 &&
                  allData?.allResourceWithCode.map((item, i) => (
                    <option
                      key={item?.id}
                      title={item?.resName}
                      value={item?.id}
                    >
                      {item?.resName}
                    </option>
                  ))}
              </select>
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Location:</span>
            <span className="add-tsk-body-row-value">
              <select
                id="providerid"
                className="chzn-select room-alot-selct width245-s"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                disabled={editMode}
              >
                <option value="all">All</option>
                {allData?.allLocation.length > 0 &&
                  allData?.allLocation.map((item, i) => (
                    <option
                      key={item?.id}
                      title={item?.location_code}
                      value={item?.id}
                    >
                      {item?.location_code}
                    </option>
                  ))}
              </select>
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Description:</span>
            <span className="add-tsk-body-row-value">
              <textarea
                id="taskDescription"
                className="add-tsk-res-txt-area"
                value={textDesc}
                onChange={(e) => setTextDesc(e.target.value)}
                disabled={editMode}
              ></textarea>
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body" style={{ display: 'flex' }}>
          <div className="add-tsk-body-row" style={{ width: '50%' }}>
            {/* <span className="add-tsk-resorce-lbl">Block Time:</span>
            <span className="add-tsk-body-row-value">
              <input
                id="block_flag"
                name="block_flag"
                type="checkbox"
                className="add-tsk-blk-tim-chk-bx"
                checked={isBlocked}
                onChange={(e) => setIsBlocked(e.target.checked)}
                disabled={editMode}
              />
            </span> */}
            <span className="add-tsk-resorce-lbl" style={{ width: '30%' }}>
              Block my calander:
            </span>
            <span className="add-tsk-body-row-value">
              <input
                id="block_calander"
                name="block_calander"
                type="radio"
                className="add-tsk-blk-tim-chk-bx"
                checked={isBlocked === '0'}
                onChange={(e) => setIsBlocked(e.target.value)}
                disabled={editMode}
                value={'0'}
              />
            </span>
          </div>
          <div className="add-tsk-body-row" style={{ width: '50%' }}>
            <span className="add-tsk-resorce-lbl" style={{ width: '30%' }}>
              Open my calander:
            </span>
            <span className="add-tsk-body-row-value">
              <input
                id="open_calander"
                name="block_calander"
                type="radio"
                className="add-tsk-blk-tim-chk-bx"
                checked={isBlocked === '2'}
                onChange={(e) => setIsBlocked(e.target.value)}
                disabled={editMode}
                value={'2'}
              />
            </span>
          </div>
        </div>
        <div className="add-tsk-main-body">
          <div className="add-tsk-body-row">
            <span className="add-tsk-resorce-lbl">Recurring:</span>
            <span className="add-tsk-body-row-value">
              <input
                type="checkbox"
                className="add-tsk-blk-tim-chk-bx"
                checked={recurringCheck}
                onChange={(e) => {
                  setRecurringCheck(e.target.checked);
                  if (e.target.checked === true) {
                    // setTaskDate({ ...taskDate, ndDate: taskDate?.stDate });
                  } else {
                    // setTaskDate({ ...taskDate, ndDate: null });
                  }
                }}
                disabled={eventData ? true : false}
              />
            </span>
          </div>
        </div>
        {recurringCheck ? (
          <div className="">
            <div className="add-tsk-main-body">
              <div className="add-tsk-body-row">
                <span className="add-tsk-resorce-lbl">Time period:</span>
                <span className="add-tsk-body-tm-prd-row-value">
                  <ReactDatePicker
                    // selected={taskDate?.stDate}
                    selected={startDateOcc}
                    onChange={(date) => {
                      // setTaskDate({ ...taskDate, stDate: date, ndDate: date })
                      setStartDateOcc(date);
                      // setEndTimeOcc(date);
                    }}
                    onClickOutside={() => {
                      setStDatePickerIsOpen(!stDatePickerIsOpen);
                    }}
                    open={stDatePickerIsOpen}
                    onSelect={() => {
                      setStDatePickerIsOpen(!stDatePickerIsOpen);
                    }}
                    className="add-task-date-picker"
                    style={{
                      width: '75px',
                    }}
                    dateFormat={DEFAULT_DATE_FORMATE}
                    // maxDate={taskDate?.ndDate}
                    disabled={editMode}
                  />
                  <img
                    width="10%"
                    src="./images/calendar-icon.png"
                    alt=""
                    onClick={() => {
                      if (editMode) return;
                      setStDatePickerIsOpen(!stDatePickerIsOpen);
                    }}
                    style={{ marginRight: '20px' }}
                  />
                  <ReactDatePicker
                    // selected={taskDate?.stDate}
                    // selected={startDateOcc}
                    selected={startTimeOcc}
                    onChange={(time) => {
                      // setTaskDate({ ...taskDate, stDate: time });
                      // setStartDateOcc(time);
                      setStartTimeOcc(time);
                      setStTimePickerIsOpen(!stTimePickerIsOpen);
                    }}
                    onClickOutside={() =>
                      setStTimePickerIsOpen(!stTimePickerIsOpen)
                    }
                    open={stTimePickerIsOpen}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    // dateFormat="h:mm aa"
                    dateFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : 'h:mm aa'
                    } // Conditional date format
                    timeFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : undefined
                    } // Conditional time format
                    placeholderText="00:00"
                    className="add-task-date-picker"
                    //maxDate={taskDate?.ndDate}
                    disabled={editMode}
                  />
                  <AccessTimeIcon
                    fontSize="small"
                    color="orange"
                    sx={{ color: 'orange' }}
                    onClick={() => {
                      if (editMode) return;
                      setStTimePickerIsOpen(!stTimePickerIsOpen);
                    }}
                  />
                </span>
                <span
                  style={{
                    fontSize: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    margin: ' 0 10px',
                    paddingTop: '10px',
                    fontWeight: '600',
                  }}
                >
                  -
                </span>
                <span className="add-tsk-body-tm-prd-row-value">
                  <ReactDatePicker
                    selected={endTimeOcc}
                    onChange={(time) => {
                      // setTaskDate({ ...taskDate, ndDate: time });
                      setEndTimeOcc(time);
                      setNdTimePickerIsOpen(!ndTimePickerIsOpen);
                    }}
                    onClickOutside={() =>
                      setNdTimePickerIsOpen(!ndTimePickerIsOpen)
                    }
                    open={ndTimePickerIsOpen}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    // dateFormat="h:mm aa"
                    dateFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : 'h:mm aa'
                    } // Conditional date format
                    timeFormat={
                      defaultTimeFormat?.withoutSecond === 'HH:mm'
                        ? 'HH:mm'
                        : undefined
                    } // Conditional time format
                    placeholderText="00:00"
                    className="add-task-date-picker"
                    //minDate={taskDate?.stDate}
                    disabled={editMode}
                  />
                  <AccessTimeIcon
                    fontSize="small"
                    color="orange"
                    sx={{ color: 'orange' }}
                    onClick={() => {
                      if (editMode) return;
                      setNdTimePickerIsOpen(!ndTimePickerIsOpen);
                    }}
                  />
                </span>
              </div>
            </div>
            <div className="add-recrnc-blk">
              <RecurrencePopup
                appDate={false}
                handleRecurranceFormData={handleRecurranceFormData}
                taskDiv={true}
              />
            </div>
          </div>
        ) : (
          <div className="add-tsk-main-body">
            <div className="add-tsk-body-row">
              <span className="add-tsk-resorce-lbl">Time period:</span>
              <span className="add-tsk-body-tm-prd-row-value">
                <ReactDatePicker
                  // selected={taskDate?.stDate}
                  selected={startDate}
                  onChange={(date) =>
                    // setTaskDate({ ...taskDate, stDate: date })
                    setStartDate(date)
                  }
                  onClickOutside={() => {
                    setStDatePickerIsOpen(!stDatePickerIsOpen);
                  }}
                  open={stDatePickerIsOpen}
                  onSelect={() => {
                    setStDatePickerIsOpen(!stDatePickerIsOpen);
                  }}
                  className="add-task-date-picker"
                  style={{
                    width: '75px',
                  }}
                  dateFormat={DEFAULT_DATE_FORMATE}
                  // maxDate={taskDate?.ndDate}
                  maxDate={endDate}
                  disabled={editMode}
                />
                <img
                  width="10%"
                  src="./images/calendar-icon.png"
                  alt=""
                  onClick={() => {
                    if (editMode) return;
                    setStDatePickerIsOpen(!stDatePickerIsOpen);
                  }}
                  style={{ marginRight: '20px' }}
                />
                <ReactDatePicker
                  // selected={taskDate?.stDate}
                  selected={startTime}
                  onChange={(time) => {
                    // setTaskDate({ ...taskDate, stDate: time });
                    setStartTime(time);
                    setStTimePickerIsOpen(!stTimePickerIsOpen);
                  }}
                  onClickOutside={() =>
                    setStTimePickerIsOpen(!stTimePickerIsOpen)
                  }
                  open={stTimePickerIsOpen}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  // dateFormat="h:mm aa"
                  dateFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : 'h:mm aa'
                  } // Conditional date format
                  timeFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : undefined
                  } // Conditional time format
                  placeholderText="00:00"
                  className="add-task-date-picker"
                  //maxDate={taskDate?.ndDate}
                  disabled={editMode}
                />
                <AccessTimeIcon
                  fontSize="small"
                  color="orange"
                  sx={{ color: 'orange' }}
                  onClick={() => {
                    if (editMode) return;
                    setStTimePickerIsOpen(!stTimePickerIsOpen);
                  }}
                />
              </span>
              <span
                style={{
                  fontSize: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  margin: ' 0 10px',
                  paddingTop: '10px',
                  fontWeight: '600',
                }}
              >
                -
              </span>
              <span className="add-tsk-body-tm-prd-row-value">
                <ReactDatePicker
                  // selected={taskDate?.ndDate}
                  selected={endDate}
                  onChange={(date) =>
                    // setTaskDate({ ...taskDate, ndDate: date })
                    setEndDate(date)
                  }
                  onClickOutside={() => {
                    setNdDatePickerIsOpen(!ndDatePickerIsOpen);
                  }}
                  open={ndDatePickerIsOpen}
                  onSelect={(dateEvent) => {
                    setNdDatePickerIsOpen(!ndDatePickerIsOpen);
                  }}
                  className="add-task-date-picker"
                  dateFormat={DEFAULT_DATE_FORMATE}
                  // minDate={taskDate?.stDate}
                  minDate={startDate}
                  disabled={editMode}
                />
                <img
                  width="10%"
                  src="./images/calendar-icon.png"
                  alt=""
                  onClick={() => {
                    if (editMode) return;
                    setNdDatePickerIsOpen(!ndDatePickerIsOpen);
                  }}
                  style={{ marginRight: '20px' }}
                />
                <ReactDatePicker
                  // selected={taskDate?.ndDate}
                  selected={endTime}
                  onChange={(time) => {
                    // setTaskDate({ ...taskDate, ndDate: time });
                    setEndTime(time);
                    setNdTimePickerIsOpen(!ndTimePickerIsOpen);
                  }}
                  onClickOutside={() =>
                    setNdTimePickerIsOpen(!ndTimePickerIsOpen)
                  }
                  open={ndTimePickerIsOpen}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  // dateFormat="h:mm aa"
                  dateFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : 'h:mm aa'
                  } // Conditional date format
                  timeFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : undefined
                  } // Conditional time format
                  placeholderText="00:00"
                  className="add-task-date-picker"
                  //minDate={taskDate?.stDate}
                  disabled={editMode}
                />
                <AccessTimeIcon
                  fontSize="small"
                  color="orange"
                  sx={{ color: 'orange' }}
                  onClick={() => {
                    if (editMode) return;
                    setNdTimePickerIsOpen(!ndTimePickerIsOpen);
                  }}
                />
              </span>
            </div>
          </div>
        )}
        <div
          className="flex-sec justify-between item-center"
          style={{ padding: '5px 10px' }}
        >
          <div>
            {fromCalFlag && eventData?.indv_task_id && (
              <Button
                variant="danger"
                onClick={() => handleDeleteTask(eventData?.indv_task_id)}
              >
                Delete
              </Button>
            )}
          </div>
          <div className="flex-sec justify-between item-center gap10">
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            {(editMode && eventData?.id && (
              <Button variant="secondary" onClick={() => setEditMode(false)}>
                Edit
              </Button>
            )) || (
              <Button variant="primary" onClick={handleSaveTask}>
                {eventData ? 'Update' : 'Save'}
              </Button>
            )}
          </div>
        </div>
      </div>
      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this task?"
          sucPrams={conFirmDelete?.id}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={handleDeleteTempletConfirm}
        />
      )}
    </div>
  );
}

export default AddTaskPopup;
